import switchTheme from "@/mixins/switchTheme";

export default function registerSwitchTheme(app) {
  app.mixin(switchTheme);
}
